import { AUTH_TELEGRAM_BOT_LOGIN } from "src/constants/constants";

export const POIZON_API_SUPPORT_LINK = "https://t.me/+qm7tbyqTgJg2ZmIy";

// Ссылка на бота, который пишет пользователю (для пункта «Разрешить писать в Telegram»).
export const TELEGRAM_BOT_LINK = `https://t.me/${AUTH_TELEGRAM_BOT_LOGIN}`;

// TODO: бот временно недоступен, ссылка указывает на общий support-чат.
// Когда бот вернётся — вернуть оригинальный URL:
//   POIZON_API_BOT_LINK → "https://t.me/PoparceBot"
export const POIZON_API_BOT_LINK = POIZON_API_SUPPORT_LINK;

export const POIZON_API_DOCS_LINK = "/knowledge-base";

export const BITRIX_FORM_LINK =
  "https://poizon-api.bitrix24.ru/bitrix/services/main/ajax.php";
